<template>
  <div style="width: 100%; display: grid; grid-template-rows: auto 1fr; padding: 20px; padding-top: 0; gap: 20px;">
    <!-- <div style="display: flex; width: 96%"> -->
    <div v-if="execute.keys" style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">

      <Button class="tabs-1 tabs-sel" @click="downXsv()">
        <Icon type="md-download" v-show="isLoad" />
        <Icon
          type="ios-loading"
          v-show="!isLoad"
          color="blue"
          size="16"
          class="okmn_btn"
        />
      </Button>
      <Select v-model=" type " style="width: auto;">
        <Option value="table">表格</Option>
        <Option value="charts">图表</Option>
      </Select>
    </div>
    <div class="resRight">
      <div v-if="type === 'table'">
        <Results :execute="execute"></Results>
      </div>
      <div v-else>
        <Chart :execute="execute" ref="charts"></Chart>
      </div>
    </div>
    <!-- 黑色蒙版 -->
    <Modal
      v-model="isShowModel"
      title="正在准备下载"
      :closable="false"
      :mask-closable="false"
    >
      <div>
        <span>请稍候，该操作可能需要一些时间...</span>
        <span
          ><Icon type="ios-loading" color="blue" size="16" class="okmn_btn" />
        </span>
      </div>

      <div slot="footer">
        <Button type="error" @click="HandCancel">取消下载</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import { mapState } from "vuex";
import Results from "./results.vue";
import Chart from "./chart.vue";
import api from "@/libs/api";
export default {
  data() {
    return {
      type: 'table',
      isSystole: true,
      isShow: true,
      isLoad: true,
      isShowModel: false,
      isLose:false,
    };
  },
  created() {},
  props: {
    execute: Object, //查询数据
    param: Object, //查询参数
  },
  components: {
    Chart,
    Results,
  },
  computed: {
    ...mapState({
      projectId: (state) => state.app.projectId,
    }),
  },

  mounted() {},
  methods: {
    HandCancel() {
      window.cancle();
      this.isShowModel = false;
      this.isLoad = true;
      this.isLose = true
    },
    downXsv() {
      this.isLose = false;
      this.isLoad = false;
      this.isShowModel = true;
      let time = this.getNowFormatDate();
      api.downloadSelectRes(this.projectId, this.param).then((res) => {
        if (res.status === 200) {
          this.isLoad = true;
          this.isShowModel = false;
          var blob = new Blob(["\ufeff" + res.data]);

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(blob, "query-impala-" + time + ".csv");
          } else {
            var a = window.document.createElement("a");
            a.href = window.URL.createObjectURL(blob, {
              type: "text/plain",
            });
            a.download = "query-impala-" + time + ".csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        } else {
          this.isShowModel = false;
          this.isLoad = true;
          if(!this.isLose){
            this.$Message.error("下载失败");
          }
        }
      });
    },
    Switching(option) {
      if (option == "table") {
        this.isShow = true;
      } else if (option == "charts") {
        this.isShow = false;
      } else if (option == "systole") {
        this.isSystole = false;
        // this.$refs.charts.menu = false;
      } else if (option == "letGo") {
        this.isSystole = true;
        // this.$refs.charts.menu = true;
      }
    },
    getNowFormatDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month >= 1 && month <= 9) month = "0" + month;
      var day = date.getDate();
      if (day >= 0 && day <= 9) day = "0" + day;
      return String(year) + String(month) + String(day);
    },
  },
};
</script>

<style scoped>
.resLeft {
  display: flex;
  flex-direction: column;
  font-size: 20px;
  margin-left: 12px;
}
.tabs-1:hover {
  color: #3b94f1;
}

.okmn_btn {
  animation: spin 1s linear infinite;
}

@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customized-queries/components/resultChart.vue